module.exports = require("@swa-ui/core/src/Tabs/Tabs.module.scss");